import { render, staticRenderFns } from "./wig-page-payments.vue?vue&type=template&id=6386d5cc"
import script from "./wig-page-payments.vue?vue&type=script&lang=js"
export * from "./wig-page-payments.vue?vue&type=script&lang=js"
import style0 from "./wig-page-payments.vue?vue&type=style&index=0&id=6386d5cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports